<template>
  <div class="section about-box">
    <!-- 无数据显示 -->
    <no-data-tips v-if="noData"></no-data-tips>
    <div class="stop-box"
         v-if="!noData">
      <div class="notice-title">{{ msg.data.title }}</div>
      <div class="time-box"></div>
      <div class="container"
           ref="contianer"></div>
      <div class="notice-company">{{ msg.data.issuer }}</div>
      <div class="bom-time">{{ msg.data.bom_time }}</div>
    </div>
  </div>
</template>

<script>
import store from '../store'
import { isInAppBrowser, messagePost } from '../utils/common'
import NoDataTips from '../components/NoDataTips'
import { fetch } from '../utils/http'
export default {
  components: {
    NoDataTips
  },
  data () {
    return {
      msg: {
        data: {
          content: '',
          title: '',
          top_time: '',
          bom_time: '',
          issuer: ''
        }
      },
      noData: false,
      id: ''
    }
  },
  methods: {
    getTxt () {
      fetch('/app/notice/detail', {
        notice_id: this.id
      }).then(res => {
        if (res.code === 'CODE_200') {
          let obj = res.data
          this.$refs.contianer.innerHTML = obj.content
          this.msg.data.title = obj.title
          this.msg.data.issuer = obj.publisher
          this.msg.data.bom_time = obj.push_at.split(' ')[0]
        } else {
          this.$mmToast(res.msg || res.msg_arr)
        }
      })
    }
  },
  mounted () {
    this.id = this.$route.query.id
    messagePost('call_back_notice')
    if (isInAppBrowser()) {
      window.passToken = res => {
        var token = JSON.parse(res).token
        store.commit('setToken', token)
        this.getTxt()
      }
    } else {
      this.getTxt()
    }
  }
}
</script>
<style>
img {
  width: 100%;
}
</style>
<style lang="scss" scoped>
$fontsize: 0.32rem;
.stop-box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  .notice-title {
    margin: 50px 0 10px 0;
    width: 100%;
    height: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 34px;
    font-weight: 900;
    color: #333;
  }
  .time-box {
    width: 90%;
    margin-left: 5%;
    height: 21px;
    position: relative;
    // margin-bottom: 30px;
    .time-line {
      position: relative;
      width: 100%;
      height: 30px;
    }
    .time-line:after {
      content: "";
      height: 2px;
      width: 100%;
      box-sizing: border-box;
      -webkit-box-sizing: border-box;
      background-color: #e3e3e3;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      transform: scale(1, 0.5);
      transform-origin: left top;
    }
    .top-time {
      width: 200px;
      height: 61px;
      background-color: #fff;
      text-align: center;
      line-height: 61px;
      font-size: 30px;
      color: #aaa;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      margin: auto;
      z-index: 3;
    }
  }
  .container {
    width: 90%;
    margin-left: 5%;
    letter-spacing: 0.02rem;
    img {
      width: 100%;
    }
  }
  .notice-company {
    width: 90%;
    margin-left: 5%;
    margin-top: 70px;
    text-align: right;
  }
  .bom-time {
    width: 90%;
    margin-top: 10px;
    margin-left: 5%;
    text-align: right;
  }
}
.about-box {
  padding-bottom: 30px;
}
</style>
